import React from "react";
import RightBar from "../assets/images/rightBar.svg";
import "./style.css";
import { useSelector } from "react-redux";
function LeftBarDesign(props) {
  let LogoImage = window.sessionStorage.getItem("logo");
  const { background } = useSelector((state) => state.theme);
  return (
    <div
      className="container-fluid"
      style={{ fontFamily: "'Montserrat', sans-serif" }}
    >
      <div className="row">
        <div
          className="col-md-9"
          style={{
            height: "100vh",
            overflow: "auto",
          }}
        >
          <div className="row">
            <div className="col-md-12 p-5">{props.innerDesign}</div>
          </div>
        </div>
        <div
          className="col-md-3 d-sm-none d-none d-md-block d-lg-block"
          style={{
            background: `${background}`,
            minHeight: "100vh",
            overflow: "hidden",
          }}
        >
          {/* <img className="design6-rightbar" src={RightBar}/> */}
          <div className="text-center mt-4">
            <img
              src={LogoImage}
              className="w-50"
              alt="logo"
            />
            <img
              className="design6-rightbar"
              src={RightBar}
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default LeftBarDesign;
